import PropTypes from "prop-types"
import cx from "classnames"
import { Text } from "components/Text"

export const Page = ({ children, padded = false }) => {
  return (
    <div className={cx({ "pt-8 lg:pt-16": padded }, "pb-20 lg:pb-40")}>
      {children}
    </div>
  )
}

Page.propTypes = {
  children: PropTypes.node,
  padded: PropTypes.bool,
}

const PageTitle = ({ children }) => {
  return (
    <Text
      variant="headline2"
      tag="h1"
      className="text-primary-dark mb-8 md:mb-10 lg:mb-12"
    >
      {children}
    </Text>
  )
}

Page.Title = PageTitle
